function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _construct(Parent, args, Class) {
    if (_is_native_reflect_construct()) {
        _construct = Reflect.construct;
    } else {
        _construct = function construct(Parent, args, Class) {
            var a = [
                null
            ];
            a.push.apply(a, args);
            var Constructor = Function.bind.apply(Parent, a);
            var instance = new Constructor();
            if (Class) _set_prototype_of(instance, Class.prototype);
            return instance;
        };
    }
    return _construct.apply(null, arguments);
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _is_native_function(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _wrap_native_super(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    _wrap_native_super = function wrapNativeSuper(Class) {
        if (Class === null || !_is_native_function(Class)) return Class;
        if (typeof Class !== "function") {
            throw new TypeError("Super expression must either be null or a function");
        }
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return _construct(Class, arguments, _get_prototype_of(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return _set_prototype_of(Wrapper, Class);
    };
    return _wrap_native_super(Class);
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
import { adopt, assignNewId, eid, extend, makeInstance, create, register } from '../utils/adopter.js';
import { find, findOne } from '../modules/core/selector.js';
import { globals } from '../utils/window.js';
import { map } from '../utils/utils.js';
import { svg, html } from '../modules/core/namespaces.js';
import EventTarget from '../types/EventTarget.js';
import List from '../types/List.js';
import attr from '../modules/core/attr.js';
var Dom = /*#__PURE__*/ function(EventTarget) {
    "use strict";
    _inherits(Dom, EventTarget);
    function Dom(node, attrs) {
        _class_call_check(this, Dom);
        var _this;
        _this = _call_super(this, Dom);
        _this.node = node;
        _this.type = node.nodeName;
        if (attrs && node !== attrs) {
            _this.attr(attrs);
        }
        return _this;
    }
    _create_class(Dom, [
        {
            // Add given element at a position
            key: "add",
            value: function add(element, i) {
                element = makeInstance(element);
                // If non-root svg nodes are added we have to remove their namespaces
                if (element.removeNamespace && _instanceof(this.node, globals.window.SVGElement)) {
                    element.removeNamespace();
                }
                if (i == null) {
                    this.node.appendChild(element.node);
                } else if (element.node !== this.node.childNodes[i]) {
                    this.node.insertBefore(element.node, this.node.childNodes[i]);
                }
                return this;
            }
        },
        {
            // Add element to given container and return self
            key: "addTo",
            value: function addTo(parent, i) {
                return makeInstance(parent).put(this, i);
            }
        },
        {
            // Returns all child elements
            key: "children",
            value: function children() {
                return new List(map(this.node.children, function(node) {
                    return adopt(node);
                }));
            }
        },
        {
            // Remove all elements in this container
            key: "clear",
            value: function clear() {
                // remove children
                while(this.node.hasChildNodes()){
                    this.node.removeChild(this.node.lastChild);
                }
                return this;
            }
        },
        {
            // Clone element
            key: "clone",
            value: function clone() {
                var deep = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true, assignNewIds = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
                // write dom data to the dom so the clone can pickup the data
                this.writeDataToDom();
                // clone element
                var nodeClone = this.node.cloneNode(deep);
                if (assignNewIds) {
                    // assign new id
                    nodeClone = assignNewId(nodeClone);
                }
                return new this.constructor(nodeClone);
            }
        },
        {
            // Iterates over all children and invokes a given block
            key: "each",
            value: function each(block, deep) {
                var children = this.children();
                var i, il;
                for(i = 0, il = children.length; i < il; i++){
                    block.apply(children[i], [
                        i,
                        children
                    ]);
                    if (deep) {
                        children[i].each(block, deep);
                    }
                }
                return this;
            }
        },
        {
            key: "element",
            value: function element(nodeName, attrs) {
                return this.put(new Dom(create(nodeName), attrs));
            }
        },
        {
            // Get first child
            key: "first",
            value: function first() {
                return adopt(this.node.firstChild);
            }
        },
        {
            // Get a element at the given index
            key: "get",
            value: function get(i) {
                return adopt(this.node.childNodes[i]);
            }
        },
        {
            key: "getEventHolder",
            value: function getEventHolder() {
                return this.node;
            }
        },
        {
            key: "getEventTarget",
            value: function getEventTarget() {
                return this.node;
            }
        },
        {
            // Checks if the given element is a child
            key: "has",
            value: function has(element) {
                return this.index(element) >= 0;
            }
        },
        {
            key: "html",
            value: function html1(htmlOrFn, outerHTML) {
                return this.xml(htmlOrFn, outerHTML, html);
            }
        },
        {
            // Get / set id
            key: "id",
            value: function id(id) {
                // generate new id if no id set
                if (typeof id === 'undefined' && !this.node.id) {
                    this.node.id = eid(this.type);
                }
                // don't set directly with this.node.id to make `null` work correctly
                return this.attr('id', id);
            }
        },
        {
            // Gets index of given element
            key: "index",
            value: function index(element) {
                return [].slice.call(this.node.childNodes).indexOf(element.node);
            }
        },
        {
            // Get the last child
            key: "last",
            value: function last() {
                return adopt(this.node.lastChild);
            }
        },
        {
            // matches the element vs a css selector
            key: "matches",
            value: function matches(selector) {
                var el = this.node;
                var matcher = el.matches || el.matchesSelector || el.msMatchesSelector || el.mozMatchesSelector || el.webkitMatchesSelector || el.oMatchesSelector || null;
                return matcher && matcher.call(el, selector);
            }
        },
        {
            // Returns the parent element instance
            key: "parent",
            value: function parent(type) {
                var parent = this;
                // check for parent
                if (!parent.node.parentNode) return null;
                // get parent element
                parent = adopt(parent.node.parentNode);
                if (!type) return parent;
                // loop through ancestors if type is given
                do {
                    if (typeof type === 'string' ? parent.matches(type) : _instanceof(parent, type)) return parent;
                }while (parent = adopt(parent.node.parentNode));
                return parent;
            }
        },
        {
            // Basically does the same as `add()` but returns the added element instead
            key: "put",
            value: function put(element, i) {
                element = makeInstance(element);
                this.add(element, i);
                return element;
            }
        },
        {
            // Add element to given container and return container
            key: "putIn",
            value: function putIn(parent, i) {
                return makeInstance(parent).add(this, i);
            }
        },
        {
            // Remove element
            key: "remove",
            value: function remove() {
                if (this.parent()) {
                    this.parent().removeElement(this);
                }
                return this;
            }
        },
        {
            // Remove a given child
            key: "removeElement",
            value: function removeElement(element) {
                this.node.removeChild(element.node);
                return this;
            }
        },
        {
            // Replace this with element
            key: "replace",
            value: function replace(element) {
                element = makeInstance(element);
                if (this.node.parentNode) {
                    this.node.parentNode.replaceChild(element.node, this.node);
                }
                return element;
            }
        },
        {
            key: "round",
            value: function round() {
                var precision = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 2, map = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
                var factor = Math.pow(10, precision);
                var attrs = this.attr(map);
                for(var i in attrs){
                    if (typeof attrs[i] === 'number') {
                        attrs[i] = Math.round(attrs[i] * factor) / factor;
                    }
                }
                this.attr(attrs);
                return this;
            }
        },
        {
            // Import / Export raw svg
            key: "svg",
            value: function svg1(svgOrFn, outerSVG) {
                return this.xml(svgOrFn, outerSVG, svg);
            }
        },
        {
            // Return id on string conversion
            key: "toString",
            value: function toString() {
                return this.id();
            }
        },
        {
            key: "words",
            value: function words(text) {
                // This is faster than removing all children and adding a new one
                this.node.textContent = text;
                return this;
            }
        },
        {
            key: "wrap",
            value: function wrap(node) {
                var parent = this.parent();
                if (!parent) {
                    return this.addTo(node);
                }
                var position = parent.index(this);
                return parent.put(node, position).put(this);
            }
        },
        {
            // write svgjs data to the dom
            key: "writeDataToDom",
            value: function writeDataToDom() {
                // dump variables recursively
                this.each(function() {
                    this.writeDataToDom();
                });
                return this;
            }
        },
        {
            // Import / Export raw svg
            key: "xml",
            value: function xml(xmlOrFn, outerXML, ns) {
                if (typeof xmlOrFn === 'boolean') {
                    ns = outerXML;
                    outerXML = xmlOrFn;
                    xmlOrFn = null;
                }
                // act as getter if no svg string is given
                if (xmlOrFn == null || typeof xmlOrFn === 'function') {
                    // The default for exports is, that the outerNode is included
                    outerXML = outerXML == null ? true : outerXML;
                    // write svgjs data to the dom
                    this.writeDataToDom();
                    var current = this;
                    // An export modifier was passed
                    if (xmlOrFn != null) {
                        current = adopt(current.node.cloneNode(true));
                        // If the user wants outerHTML we need to process this node, too
                        if (outerXML) {
                            var result = xmlOrFn(current);
                            current = result || current;
                            // The user does not want this node? Well, then he gets nothing
                            if (result === false) return '';
                        }
                        // Deep loop through all children and apply modifier
                        current.each(function() {
                            var result = xmlOrFn(this);
                            var _this = result || this;
                            // If modifier returns false, discard node
                            if (result === false) {
                                this.remove();
                            // If modifier returns new node, use it
                            } else if (result && this !== _this) {
                                this.replace(_this);
                            }
                        }, true);
                    }
                    // Return outer or inner content
                    return outerXML ? current.node.outerHTML : current.node.innerHTML;
                }
                // Act as setter if we got a string
                // The default for import is, that the current node is not replaced
                outerXML = outerXML == null ? false : outerXML;
                // Create temporary holder
                var well = create('wrapper', ns);
                var fragment = globals.document.createDocumentFragment();
                // Dump raw svg
                well.innerHTML = xmlOrFn;
                // Transplant nodes into the fragment
                for(var len = well.children.length; len--;){
                    fragment.appendChild(well.firstElementChild);
                }
                var parent = this.parent();
                // Add the whole fragment at once
                return outerXML ? this.replace(fragment) && parent : this.add(fragment);
            }
        }
    ]);
    return Dom;
}(_wrap_native_super(EventTarget));
export { Dom as default };
extend(Dom, {
    attr: attr,
    find: find,
    findOne: findOne
});
register(Dom, 'Dom');
